__turbopack_context__.v({
  "className": "noto_sans_khmer_6e77fff2-module__USt6JW__className",
});
